<h1>Notifications</h1>
<button class="btn mr-2 mb-4 btn-light-gray" (click)="showNotification('Test', 'It`s working!')">Show test message</button>
<div class="card p-3 mb-3" *ngFor="let notification of userNotifications">
  <p class="m-0 h6 card__header--important">{{ notification.title }}</p>
  <p class="m-0">{{ notification.text }}</p>
  <p class="text-right m-0">{{ notification.date | date: 'dd.MM.yyyy HH:mm' }}</p>
</div>
